export const BELONGS_TO = 'belongsTo';
export const HAS_MANY = 'hasMany';
